import { DefaultTheme } from '../../components/theme';

export const CSS = {
	container: 'c-OmniSearch',
	icon: 'c-OmniSearch__icon',
	input: 'c-OmniSearch__input',
	clear: 'c-OmniSearch__clear',
};

export const Style = {
	[CSS.container]: {
		'background-color': DefaultTheme.background.mediumGrey,
		padding: `0 ${DefaultTheme.space(2)}`,
		display: 'flex',
		'align-items': 'center',
		color: DefaultTheme.font.color.white,
	},
	[CSS.input]: {
		flex: '1',
		border: 'none',
		outline: 'none',
		'background-color': 'transparent',
		'font-family': DefaultTheme.font.family,
		'font-size': DefaultTheme.font.size,
		color: DefaultTheme.font.color.white,
		'margin-left': DefaultTheme.space(4),
	},
	[`${CSS.input}::placeholder`]: {
		opacity: '0.6',
		color: DefaultTheme.font.color.white,
		transition: 'opacity 0.2s ease',
	},
	[CSS.clear]: {
		color: DefaultTheme.font.color.white,
	},
	[`${CSS.input}:focus::placeholder`]: {
		opacity: '0.8',
		color: DefaultTheme.font.color.white,
	},
	[CSS.icon]: {
		'pointer-events': 'none',
	},
};
